import React, { useState, useEffect } from 'react';
import {recipeSaveService} from "../../services/recipeSaveService";
import {DIGITS_REG_EXP} from "../../constant";
import { useTranslation } from 'react-i18next';
import { Input } from '@chapche/ui';

const RecipeIngredientNumberValue = ({ingredientsGroup, ingredientsGroupNumber, fieldValue}) => {
    const { i18n } = useTranslation();
    const [currentValue, setCurrentValue] = useState(0);

    const changeIngredientGroupNumber = (e) => {
        if(e.target.value.match(DIGITS_REG_EXP) || e.target.value === '') {
            setCurrentValue(e.target.value);
            recipeSaveService.updateIngredientGroupMaxNumber(ingredientsGroup, ingredientsGroupNumber, e.target.value);
        }
    };

    useEffect(() => {
        setCurrentValue(fieldValue);
    }, [ingredientsGroup, ingredientsGroupNumber]);

    return (
        <label key={ingredientsGroup + ingredientsGroupNumber} className="block__text product__form-label product__add-label">
            <span className="product__form-number product__form-label_text">{ingredientsGroupNumber} {i18n.t('product.scheme.property.code.valueOfData')}</span>
            <Input
                fullWidth
                className="mt-0"
                value={currentValue}
                onChange={changeIngredientGroupNumber}
                name={ingredientsGroup}
            />
        </label>
    );
};

export default RecipeIngredientNumberValue;
